import React, { useEffect, useState } from "react";
import Layout from "../common/layout";
import "./styles.css";
import { useDispatch, useSelector } from "react-redux";
import { useSelect } from "@mui/base";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VideoPlayer, {
  ANYTIME_WEBINAR_START_OVER_EVENT,
  clearAnytimeWebinarProgressCookie,
} from "./VideoPlayer";
import ChatMassage from "./ChatMassage";
import {
  Box,
  Button,
  CircularProgress,
  Unstable_Grid2 as Grid,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Participants from "./Participents";
import useWebSocket, { ReadyState } from "react-use-websocket";
import appConfig from "../../utils/constant/appConfig";
import { chatReport, getVideoHlsPath } from "../../utils/apis/apis";
import ErrorPage, { StartWebinar } from "./../pageNotFound/index";
import * as sessionActions from "../../store/session";
import { Helmet } from "react-helmet-async";
let durationTime = 0;
export default function WebinarView() {
  const sessionUser = useSelector((state) => state.session.user);
  const navigate = useNavigate();
  const { webinarId } = useParams();
  const [value, setValue] = React.useState(0);
  const [ListData, setListdata] = useState([]);
  const [ActiveData, setActiveListdata] = useState([]);
  const [InactiveData, setInactiveListdata] = useState([]);
  const [startDummyUserChat, setStartDummyUserChat] = useState(false);
  const [hlsUrl, setHlsUrl] = useState("");
  const [liveWebinarInfo, setLiveWebinarInfo] = useState({});
  const [liveWebinarIsActive, setLiveWebinarIsActive] = useState(false);
  // Whether this webinar was configured as "anytime" on the admin side.
  // Pulled from the VideoAccessAPI response (`is_anytime_webinar`). When
  // true the watch-room renders a "Start from beginning" button next to
  // the Leave button and the underlying VideoPlayer enables cookie-based
  // progress saving + resume.
  const [isAnytimeWebinar, setIsAnytimeWebinar] = useState(false);
  // Per-webinar admin permission – whether anytime-webinar viewers are
  // allowed to restart the webinar from 0 via the "Start from
  // beginning" button. Pulled from the VideoAccessAPI response
  // (`allow_anytime_restart`). Defaults to true when the field is
  // missing (e.g. older webinars created before this column existed),
  // mirroring the model default. Has no visual effect when
  // `isAnytimeWebinar` is false.
  const [allowAnytimeRestart, setAllowAnytimeRestart] = useState(true);
  // Whether this webinar was configured as "scrollable" on the admin
  // side. Pulled from the VideoAccessAPI response
  // (`is_scrollable_webinar`). When true the underlying VideoPlayer
  // renders native browser controls so the viewer can scroll / scrub
  // through the video timeline. Defaults to false to preserve the
  // historical locked-down playback experience.
  const [isScrollableWebinar, setIsScrollableWebinar] = useState(false);
  const filterActiveList = ListData.filter((list) => {
    return list.status === "active";
  });
  const filterInactiveList = ListData.filter((list) => {
    return list.status === "Inactive";
  });
  const [tabIndex, setTabIndex] = useState(0);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [webinarParticepents, setWebinarParticepents] = useState([]);
  const [webinarChats, setWebinarChats] = useState([]);
  const [webinarAllChats, setWebinarAllChats] = useState([]);
  const [durations, setDurations] = useState("");
  const [loading, setLoading] = useState(true);
  const [getTitle,setGetTtitle] = useState('');
  const [getDesc,setGetDesc] = useState('');
  const participantsLabel = `Participants (${webinarParticepents.length})`;
  const chatsLabel = `Chats (${webinarChats.length})`;
  const [isAdminUser, setIsAdminUser] = React.useState(" ");
  const [isClicked, setIsClicked] = useState(false);
  const dispatch = useDispatch();
  const handleTabChange = (e, tabIndex) => {
    setCurrentTabIndex(tabIndex);
  };
  const location = useLocation();
  const socketUrl = `${appConfig.WEB_SOCKET_URL}/${sessionUser?.id}/${webinarId}/`;
  useEffect(() => {
    if (sessionUser?.id && webinarId) {
      const socketUrl = `${appConfig.WEB_SOCKET_URL}/${sessionUser.id}/${webinarId}/`;
    }
  }, [sessionUser, webinarId]);
  const socketOptions = {
    shouldReconnect: () => true,
  };
  const { sendMessage, lastMessage, readyState } = useWebSocket(
    socketUrl,
    socketOptions
  );
  useEffect(() => {
    var msgList = [];
    if (lastMessage) {
      const lastData = JSON.parse(lastMessage.data);
      if (lastData.participants.length > 0) {
        setWebinarParticepents(lastData.participants);
      }
      if (lastData.chatmsg) {
        setWebinarChats((prevMessages) => [...prevMessages, lastData.chatmsg]);
      }
    }
  }, [lastMessage]);

  const sendTxtMsg = (val) => {
    const inputData = val.replace(/\n/g, " ").replace(/\s+/g, " ").trim();
    sendMessage(
      `{"token":"","text":"${inputData}","type":"chat_msg","sessionTime":"${durationTime}","totalDuration":"${durations}"}`
    );
  };
  useEffect(() => {
    setTimeout(() => {
      sendMessage(
        `{"token":"","text":"${"i am join"}","type":"user_join","sessionTime":"0.750061","totalDuration":"${durations}"}`
      );
    }, 3000);
  }, []);

  useEffect(() => {
    videoURLFile();
  }, []);
  const videoURLFile = async () => {
    await getVideoHlsPath(webinarId)
      .then((val) => {
        if (val.reschedule == true) {
          videoURLFile();
        } else {
          setHlsUrl(val.video_url);
          setGetTtitle(val.name)
          setGetDesc(val.title)
          setLiveWebinarInfo(val);
          setLiveWebinarIsActive(val.active);
          // Capture the anytime-webinar flag so we know whether to enable
          // cookie-based resume + the "Start from beginning" button. The
          // backend (VideoAccessAPI) returns `is_anytime_webinar` on every
          // response shape (active / inactive / unscheduled).
          setIsAnytimeWebinar(!!val.is_anytime_webinar);
          // Capture the per-webinar restart permission. Field may be
          // undefined for older webinars – treat that as "allowed" to
          // match the model default.
          setAllowAnytimeRestart(
            val.allow_anytime_restart === undefined
              ? true
              : !!val.allow_anytime_restart
          );
          // Capture whether this webinar should render with native
          // video controls so the viewer can scroll / scrub through
          // the timeline. Field may be undefined for older webinars
          // (created before this column existed) – treat that as
          // false to keep the legacy locked-down behaviour.
          setIsScrollableWebinar(!!val.is_scrollable_webinar);
          setLoading(false);
          if (val.is_schedule == true) {
            allChatMsg();
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const allChatMsg = async () => {
    await chatReport(sessionUser.access, webinarId)
      .then((val) => {
        let jsonData = val.data;
        jsonData.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setWebinarChats((prevMessages) => [...prevMessages, ...jsonData]);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    if (userInfo) {
      const localStorageUserId = userInfo.id;
      const webinarChatsUserId = webinarChats[0]?.userId;

      if (localStorageUserId === webinarChatsUserId) {
      } else {
      }

      setIsAdminUser(localStorageUserId === webinarChatsUserId);
    } else {
    }
  }, [dispatch, webinarChats]);
  const handleClick = () => {
    setIsClicked(true); 
  };
  /**
   * "Start from beginning" handler – only rendered for anytime webinars.
   *
   * Clears the per-webinar progress cookie and broadcasts a custom DOM
   * event so the active VideoPlayer instance seeks back to 0. We use a
   * window-level event (instead of e.g. a ref) to keep the watch-room and
   * the player loosely coupled – the player owns its own seek logic.
   */
  const handleStartFromBeginning = () => {
    if (webinarId) {
      clearAnytimeWebinarProgressCookie(webinarId);
    }
    window.dispatchEvent(new CustomEvent(ANYTIME_WEBINAR_START_OVER_EVENT));
  };
  return (
    <>
      {hlsUrl && loading == false && liveWebinarIsActive == true ? (
         <Layout active={1} isLeave>
        <Helmet>
          <title>Letswebinar | {getTitle}</title>
        </Helmet>
          <>
            <div className="ssss" onClick={handleClick}>
              <Grid
                container
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  background: "black",
                }}
              >
                <Grid
                  item
                  xs={12}
                  lg={9}
                  md={9}
                  style={{
                    position: "static",
                    top: "10%",
                    left: "0",
                    overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <div className="container-webinarview">
                    {/*
                      Anytime-webinar only: render a "Start from beginning"
                      button at the top of the video container, next to
                      where the Leave button (in the Header) sits. Clicking
                      it clears the saved progress cookie and asks the
                      VideoPlayer to seek back to 0 via a window event.

                      The button is additionally gated on
                      `allowAnytimeRestart` so admins can disable the
                      restart capability per-webinar (e.g. for evergreen
                      sales webinars that must always play in sequence
                      from where the viewer left off). Cookie-based
                      resume itself is unaffected by this flag.
                    */}
                    {isAnytimeWebinar && allowAnytimeRestart && (
                      <div
                        className="anytime-start-over-bar"
                        style={{
                          position: "absolute",
                          top: 12,
                          right: 12,
                          zIndex: 1000,
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={handleStartFromBeginning}
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                          }}
                        >
                          Start from beginning
                        </Button>
                      </div>
                    )}
                    <VideoPlayer
                      style={{ maxHeight: "933px", overflow: "hidden" }}
                      videoUrl={hlsUrl}
                      startVideoDuration={
                        liveWebinarInfo?.webinar_video_duration
                      }
                      isAnytimeWebinar={isAnytimeWebinar}
                      // When the admin has marked this webinar as
                      // "scrollable" we render the underlying video
                      // player with native controls (play/pause, seek
                      // bar, volume, fullscreen, etc.) so the viewer
                      // can freely scroll / scrub through the video
                      // timeline.
                      isScrollableWebinar={isScrollableWebinar}
                      getSecondValue={(val) => {
                        durationTime = val;
                        sendMessage(
                          `{"token":"09AHfSPUdJAkTz8DxX1ZAAXvGt2w8IO7sCkRnJCOo","text":"${"hello"}","type":"chat_msg","sessionTime":"${val}","totalDuration":"${durations}"}`
                        );
                      }}
                      totalDuration={(val) => {
                        setDurations(val);
                        sendMessage(
                          `{"token":"09AHfSPUdJAkTz8DxX1ZAAXvGt2w8IO7sCkRnJCOo","text":"${"hello"}","type":"chat_msg","sessionTime":"0.750061","totalDuration":"${val}"}`
                        );
                      }}
                      isClicked={isClicked}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <div>
                    <Box
                      sx={{
                        borderRight: 1,
                        borderColor: "divider",
                        backgroundColor: "#f5f3f0",
                      }}
                    >
                      <>
                        <Tabs
                          value={currentTabIndex}
                          onChange={handleTabChange}
                          style={{ borderBottom: "2px solid #554d4d94" }}
                        >
                          <Tab
                            label={participantsLabel}
                            className="participant-tab"
                          />
                          <Tab label={chatsLabel} className="m-chats" />
                        </Tabs>

                        {currentTabIndex === 0 && (
                          <Box className='p-participant'>
                            <Participants
                              style={{ height: " calc(100% - 50px)" }}
                              webinarParticepents={webinarParticepents}
                            />
                          </Box>
                        )}

                        {currentTabIndex === 1 && (
                          <Box>
                            <ChatMassage
                              className="msger"
                              sx={{ padding: "12px 0px" }}
                              webinarChats={webinarChats}
                              webinarId={webinarId}
                              isAdminUser={isAdminUser}
                              send={(val) => {
                                sendTxtMsg(val);
                              }}
                            />
                          </Box>
                        )}
                      </>
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </div>
          </>
        </Layout>
      ) : loading && hlsUrl == "" ? (
        <CircularProgress className="cicular_loader"/>
      ) : (
        <>
          {liveWebinarIsActive == false ? (
            <StartWebinar
              getSeconds={() => {
                setLiveWebinarIsActive(true);
              }}
              startTime={liveWebinarInfo?.duration_time}
            />
          ) : (
            <ErrorPage />
          )}
        </>
      )}
    </>
  );
}
